import { TestType } from 'types/api/testType';
import { PassLabel } from './types';

const getPassLabel = (key: TestType): PassLabel =>
  key === 'knowledge' ? 'passed' : 'reliable';

export default getPassLabel;
